
























import {Component} from "vue-property-decorator";
import {Store} from "@/enums/Store";
import {InputType} from "@/enums/InputType";
import {ValidationMode} from "@/enums/ValidationMode";
import {Option} from "@/util/Option";
import {Event} from "@/util/Event";
import {PlaceholderLocation} from "@/util/Location";
import {extend} from 'vee-validate';
import {locationCodeRuleCreator} from "@/util/Rules";
import {namespace} from 'vuex-class';
import FormGroup from "@/components/Form/InputComponents/FormGroup.vue";
import FormSelect from "@/components/Form/InputComponents/FormSelect.vue";
import FormInput from "@/components/Form/InputComponents/FormInput.vue";
import Validatable from "@/components/Validatable.vue";
import {LocationInterface} from "@/types/Location";
import SearchFormInput from "@/components/Form/InputComponents/SearchFormInput.vue";

const APP = namespace(Store.APP);
const LOCATION = namespace(Store.LOCATION);
const EVENT = namespace(Store.EVENT);

@Component({
  components: {SearchFormInput, FormInput, FormSelect, FormGroup}
})
export default class LocationForm extends Validatable {
  @APP.Mutation('ADD_ERROR') addError!: (error: Error) => void
  @EVENT.Action('filterEventLocations') filterEventLocations!: (locations: LocationInterface[]) => void
  @EVENT.Getter('selectedEventObject') event!: Event;
  @LOCATION.State('locationCode') locationCode?: string;
  @LOCATION.State('location') location!: PlaceholderLocation;
  @LOCATION.Mutation('SET_SELECTED_LOCATION_CODE') setLocationCode!: (locationCode: string) => void;
  @LOCATION.Mutation('SET_SELECTED_LOCATION') setLocationObject!: (location: Location) => void;
  @LOCATION.Action('setSelectedLocation') setLocation!: (locationId: string) => void;

  PASSIVE = ValidationMode.Passive;
  TEXT = InputType.TEXT;
  requireLocationId = true;
  requireLocationCode = true;
  openLocationKey = 0;
  closedLocationKey = 0;
  filter = '';

  set locationId(val: string | undefined) {
    this.$set(this.location, 'id', val);
  }

  get locationId() {
    const option = this.locations.find((option: Option) => {
      return option.value == this.location.id;
    });

    if (!option) {
      return undefined
    }

    return this.location.id
  }

  get locations(){
    const options: Option[] = this.event.locations.map(location => ({
      text: location.name,
      value: location.id
    }))

    return options
  }

  created(): void {
    const locationCode = locationCodeRuleCreator(this.$api, this.event.id, this.addError);

    extend('location-code', {
      ...locationCode,
      message: this.$t('location-code-invalid').toString()
    });

    this.requireLocationId = !this.locationCode;

    if (this.locationCode) {
      this.requireLocationCode = true;
    } else if (!this.location.id) {
      this.requireLocationCode = true;
    } else {
      this.requireLocationCode = false;
    }
  }

  async updateLocation(locationId: string) {
    this.requireLocationCode = !locationId;
    this.setLocation(locationId);
    this.closedLocationKey++
  }

  async updateLocationCode(locationCode: string) {
    this.requireLocationId = !locationCode;
    this.setLocationCode(locationCode);
    this.openLocationKey++
  }

  async validate(silent = false) {
    const superClass = (this.constructor as any).super;
    const methods = superClass.options.methods;
    const res = await methods.validate.call(this, silent);

    if (!res) {
      return false;
    }

    if (!this.requireLocationCode) {
      return res;
    }

    try {
      const location = await this.$api.get<Location>(`/events/${this.event.id}/locationCode/${this.locationCode}`);
      if (location) {
        this.setLocationObject(location);
        return true;
      }
    } catch (e) {
      this.addError(e);
      return false;
    }
  }
}
